import { useEffect, useState } from "react";
import * as brain from 'brain.js';
import "./App.css";
import StringToComponent from "./StringToComponent";
import PopupImage from "./popups/PopupImage";
import DesignGenerator from "./DesignGenerator";
import Navbar_1 from "./navbar/Navbar_1";
import Hero_5 from "./hero/Hero_5";
import Testimonials_1 from "./testimonials/Testimonials_1";
import About_6 from "./about/About_6";
import Service_3 from "./service/Service_3";
import Footer_1 from "./footer/Footer_1";
import Contact_3 from "./contact/Contact_3";
import Hero_3 from "./hero/Hero_3";
import Hero_6 from "./hero/Hero_6";
import Hero_1 from "./hero/Hero_1";
import Navbar_2 from "./navbar/Navbar_2";
import Navbar_3 from "./navbar/Navbar_3";
import Testimonials_2 from "./testimonials/Testimonials_2";
import Service_1 from "./service/Service_1";
import Service_2 from "./service/Service_2";
import Service_5 from "./service/Service_5";
import Service_10 from "./service/Service_10";
import Service_9 from "./service/Service_9";
import Service_8 from "./service/Service_8";
import Contact_1 from "./contact/Contact_1";
import Contact_2 from "./contact/Contact_2";
import Contact_4 from "./contact/Contact_4";
import Prices_1 from "./prices/Prices_1";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Prices_4 from "./prices/Prices_4";
import Prices_5 from "./prices/Prices_5";
import Prices_6 from "./prices/Prices_6";
import Prices_7 from "./prices/Prices_7";
import Prices_8 from "./prices/Prices_8";

function App() {
  
  // const net = new brain.NeuralNetwork();
  // const [trainingData, setTrainingData] = useState(
  //   [{"input":{"navbar":2,"hero":5,"about":8,"faq":2,"service":7,"contact":3,"testimonials":1,"footer":1},"output":[1]},{"input":{"navbar":1,"hero":3,"about":5,"faq":1,"service":4,"contact":2,"testimonials":2,"footer":1},"output":[0]},{"input":{"navbar":1,"hero":"Hero_6","about":"About_3","faq":"Faq_2","service":"Service_2","contact":"Contact_5","testimonials":"Testimonials_1","footer":"Footer_1"},"output":[1]},{"input":{"navbar":"Navbar_2","hero":"Hero_7","about":"About_4","faq":"Faq_2","service":"Service_7","contact":"Contact_3","testimonials":"Testimonials_2","footer":"Footer_1"},"output":[1]},{"input":{"navbar":"Navbar_3","hero":"Hero_1","about":"About_4","faq":"Faq_2","service":"Service_3","contact":"Contact_4","testimonials":"Testimonials_1","footer":"Footer_1"},"output":[1]},{"input":{"navbar":"Navbar_3","hero":"Hero_8","about":"About_7","faq":"Faq_1","service":"Service_7","contact":"Contact_4","testimonials":"Testimonials_2","footer":"Footer_1"},"output":[1]},{"input":{"navbar":"Navbar_2","hero":"Hero_7","about":"About_3","faq":"Faq_1","service":"Service_5","contact":"Contact_4","testimonials":"Testimonials_1","footer":"Footer_1"},"output":[1]},{"input":{"navbar":"Navbar_3","hero":"Hero_3","about":"About_7","faq":"Faq_2","service":"Service_7","contact":"Contact_2","testimonials":"Testimonials_2","footer":"Footer_1"},"output":[1]},{"input":{"navbar":"Navbar_2","hero":"Hero_6","about":"About_3","faq":"Faq_1","service":"Service_4","contact":"Contact_1","testimonials":"Testimonials_2","footer":"Footer_1"},"output":[1]},{"input":{"navbar":"Navbar_2","hero":"Hero_4","about":"About_5","faq":"Faq_1","service":"Service_8","contact":"Contact_1","testimonials":"Testimonials_1","footer":"Footer_1"},"output":[1]},{"input":{"navbar":"Navbar_1","hero":"Hero_9","about":"About_6","faq":"Faq_2","service":"Service_9","contact":"Contact_4","testimonials":"Testimonials_2","footer":"Footer_1"},"output":[0]},{"input":{"navbar":"Navbar_2","hero":"Hero_5","about":"About_4","faq":"Faq_1","service":"Service_3","contact":"Contact_1","testimonials":"Testimonials_2","footer":"Footer_1"},"output":[1]},{"input":{"navbar":"Navbar_3","hero":"Hero_5","about":"About_3","faq":"Faq_2","service":"Service_10","contact":"Contact_1","testimonials":"Testimonials_1","footer":"Footer_1"},"output":[1]},{"input":{"navbar":"Navbar_1","hero":"Hero_7","about":"About_4","faq":"Faq_2","service":"Service_8","contact":"Contact_5","testimonials":"Testimonials_2","footer":"Footer_1"},"output":[0]},{"input":{"navbar":"Navbar_3","hero":"Hero_8","about":"About_6","faq":"Faq_2","service":"Service_9","contact":"Contact_4","testimonials":"Testimonials_2","footer":"Footer_1"},"output":[1]},{"input":{"navbar":"Navbar_3","hero":"Hero_1","about":"About_3","faq":"Faq_2","service":"Service_3","contact":"Contact_3","testimonials":"Testimonials_1","footer":"Footer_1"},"output":[1]},{"input":{"navbar":"Navbar_2","hero":"Hero_7","about":"About_6","faq":"Faq_1","service":"Service_2","contact":"Contact_4","testimonials":"Testimonials_2","footer":"Footer_1"},"output":[1]},{"input":{"navbar":"Navbar_1","hero":"Hero_8","about":"About_6","faq":"Faq_1","service":"Service_3","contact":"Contact_3","testimonials":"Testimonials_2","footer":"Footer_1"},"output":[1]},{"input":{"navbar":"Navbar_3","hero":"Hero_7","about":"About_7","faq":"Faq_1","service":"Service_10","contact":"Contact_2","testimonials":"Testimonials_2","footer":"Footer_1"},"output":[1]},{"input":{"navbar":1,"hero":1,"about":3,"faq":2,"service":6,"contact":4,"testimonials":1,"footer":1},"output":[1]},{"input":{"navbar":2,"hero":7,"about":5,"faq":2,"service":6,"contact":4,"testimonials":2,"footer":1},"output":[0]},{"input":{"navbar":3,"hero":9,"about":5,"faq":2,"service":2,"contact":5,"testimonials":2,"footer":1},"output":[1]},{"input":{"navbar":2,"hero":9,"about":3,"faq":1,"service":1,"contact":1,"testimonials":2,"footer":1},"output":[1]},{"input":{"navbar":2,"hero":1,"about":6,"faq":1,"service":6,"contact":5,"testimonials":1,"footer":1},"output":[1]},{"input":{"navbar":1,"hero":6,"about":4,"faq":1,"service":4,"contact":1,"testimonials":2,"footer":1},"output":[1]},{"input":{"navbar":1,"hero":5,"about":7,"faq":2,"service":9,"contact":3,"testimonials":2,"footer":1},"output":[1]},{"input":{"navbar":1,"hero":2,"about":6,"faq":2,"service":10,"contact":2,"testimonials":1,"footer":1},"output":[1]},{"input":{"navbar":3,"hero":1,"about":5,"faq":2,"service":8,"contact":2,"testimonials":2,"footer":1},"output":[1]},{"input":{"navbar":3,"hero":4,"about":3,"faq":1,"service":3,"contact":3,"testimonials":2,"footer":1},"output":[1]},{"input":{"navbar":1,"hero":1,"about":4,"faq":1,"service":8,"contact":3,"testimonials":1,"footer":1},"output":[1]},{"input":{"navbar":1,"hero":3,"about":4,"faq":2,"service":9,"contact":3,"testimonials":2,"footer":1},"output":[1]},{"input":{"navbar":1,"hero":9,"about":3,"faq":1,"service":8,"contact":4,"testimonials":2,"footer":1},"output":[1]},{"input":{"navbar":3,"hero":5,"about":7,"faq":2,"service":4,"contact":1,"testimonials":2,"footer":1},"output":[1]},{"input":{"navbar":2,"hero":9,"about":6,"faq":1,"service":6,"contact":2,"testimonials":1,"footer":1},"output":[1]},{"input":{"navbar":2,"hero":4,"about":4,"faq":1,"service":3,"contact":1,"testimonials":1,"footer":1},"output":[1]},{"input":{"navbar":2,"hero":2,"about":6,"faq":2,"service":10,"contact":2,"testimonials":1,"footer":1},"output":[1]},{"input":{"navbar":3,"hero":7,"about":3,"faq":1,"service":5,"contact":2,"testimonials":2,"footer":1},"output":[1]},{"input":{"navbar":2,"hero":6,"about":4,"faq":1,"service":9,"contact":3,"testimonials":2,"footer":1},"output":[1]},{"input":{"navbar":1,"hero":3,"about":3,"faq":2,"service":3,"contact":2,"testimonials":2,"footer":1},"output":[1]},{"input":{"navbar":1,"hero":6,"about":7,"faq":1,"service":7,"contact":5,"testimonials":2,"footer":1},"output":[1]},{"input":{"navbar":2,"hero":9,"about":3,"faq":1,"service":8,"contact":3,"testimonials":2,"footer":1},"output":[1]},{"input":{"navbar":3,"hero":4,"about":4,"faq":1,"service":6,"contact":4,"testimonials":2,"footer":1},"output":[1]},{"input":{"navbar":3,"hero":4,"about":6,"faq":2,"service":10,"contact":4,"testimonials":1,"footer":1},"output":[1]},{"input":{"navbar":1,"hero":8,"about":4,"faq":1,"service":2,"contact":2,"testimonials":1,"footer":1},"output":[1]},{"input":{"navbar":2,"hero":5,"about":3,"faq":1,"service":4,"contact":2,"testimonials":2,"footer":1},"output":[1]},{"input":{"navbar":3,"hero":1,"about":7,"faq":1,"service":4,"contact":1,"testimonials":1,"footer":1},"output":[1]},{"input":{"navbar":3,"hero":1,"about":7,"faq":2,"service":8,"contact":2,"testimonials":1,"footer":1},"output":[1]},{"input":{"navbar":3,"hero":3,"about":6,"faq":2,"service":5,"contact":5,"testimonials":2,"footer":1},"output":[1]},{"input":{"navbar":1,"hero":8,"about":4,"faq":2,"service":1,"contact":1,"testimonials":1,"footer":1},"output":[1]},{"input":{"navbar":3,"hero":8,"about":7,"faq":1,"service":10,"contact":2,"testimonials":1,"footer":1},"output":[1]},{"input":{"navbar":3,"hero":2,"about":7,"faq":2,"service":1,"contact":5,"testimonials":1,"footer":1},"output":[1]},{"input":{"navbar":2,"hero":7,"about":3,"faq":1,"service":3,"contact":2,"testimonials":2,"footer":1},"output":[1]},{"input":{"navbar":3,"hero":3,"about":5,"faq":1,"service":8,"contact":4,"testimonials":1,"footer":1},"output":[1]},{"input":{"navbar":2,"hero":5,"about":7,"faq":2,"service":6,"contact":2,"testimonials":1,"footer":1},"output":[0]},{"input":{"navbar":2,"hero":9,"about":4,"faq":2,"service":10,"contact":3,"testimonials":2,"footer":1},"output":[1]},{"input":{"navbar":2,"hero":3,"about":3,"faq":2,"service":10,"contact":4,"testimonials":2,"footer":1},"output":[1]},{"input":{"navbar":1,"hero":2,"about":5,"faq":1,"service":4,"contact":5,"testimonials":2,"footer":1},"output":[1]},{"input":{"navbar":2,"hero":9,"about":5,"faq":2,"service":4,"contact":4,"testimonials":1,"footer":1},"output":[1]},{"input":{"navbar":3,"hero":5,"about":6,"faq":2,"service":9,"contact":4,"testimonials":1,"footer":1},"output":[1]},{"input":{"navbar":3,"hero":1,"about":4,"faq":2,"service":6,"contact":4,"testimonials":1,"footer":1},"output":[1]},{"input":{"navbar":1,"hero":2,"about":7,"faq":1,"service":4,"contact":2,"testimonials":2,"footer":1},"output":[0]},{"input":{"navbar":1,"hero":1,"about":4,"faq":2,"service":8,"contact":4,"testimonials":1,"footer":1},"output":[1]},{"input":{"navbar":1,"hero":4,"about":3,"faq":2,"service":9,"contact":2,"testimonials":2,"footer":1},"output":[1]},{"input":{"navbar":3,"hero":6,"about":7,"faq":1,"service":6,"contact":5,"testimonials":1,"footer":1},"output":[1]},{"input":{"navbar":2,"hero":3,"about":7,"faq":2,"service":1,"contact":2,"testimonials":1,"footer":1},"output":[1]},{"input":{"navbar":3,"hero":6,"about":3,"faq":2,"service":9,"contact":4,"testimonials":1,"footer":1},"output":[1]},{"input":{"navbar":3,"hero":4,"about":6,"faq":2,"service":2,"contact":5,"testimonials":1,"footer":1},"output":[1]},{"input":{"navbar":1,"hero":4,"about":5,"faq":2,"service":9,"contact":2,"testimonials":2,"footer":1},"output":[0]},{"input":{"navbar":2,"hero":5,"about":4,"faq":1,"service":9,"contact":4,"testimonials":1,"footer":1},"output":[1]},{"input":{"navbar":2,"hero":3,"about":5,"faq":2,"service":6,"contact":3,"testimonials":2,"footer":1},"output":[1]}]
  // );
  // net.train(trainingData);
  

  // const getRandomInt = (min, max) => {
  //   return Math.floor(Math.random() * (max - min + 1)) + min;
  // };

  // useEffect(() => {
  //   // Create a simple XOR neural network
    

  //   // Training data for XOR
    
  //   // Train the neural network
    

  //   // Test the neural network
  //   // console.log('Output for' + ', output00);
  //   // console.log('Output for [0, 1]:', output01);
   
  // }, []);

  // const generateRandomQuantities = () => {
  //   const newDesign = {
  //     'navbar': getRandomInt(1, 3),
  //     'hero': getRandomInt(1, 9),
  //     'about': getRandomInt(3, 7),
  //     'faq': getRandomInt(1, 2),
  //     'service': getRandomInt(1, 10),
  //     'contact': getRandomInt(1, 5),
  //     'testimonials': getRandomInt(1, 2),
  //     'footer': getRandomInt(1, 1),
  //   };
  //   return newDesign;
  // }

  // const generateRandomDesign = () => {
  //   const newDesign = generateRandomQuantities()

  //   const NavbarComponent = "Navbar_" + newDesign['navbar'];
  //   const HeroComponent = "Hero_" + newDesign['hero'];
  //   const AboutComponent = "About_" + newDesign['about'];
  //   const FAQComponent = "Faq_" + newDesign['faq'];
  //   const ServiceComponent = "Service_" + newDesign['service'];
  //   const ContactComponent = "Contact_" + newDesign['contact'];
  //   const TestimonialsComponent = "Testimonials_" + newDesign['testimonials'];
  //   const FooterComponenet = "Footer_" + newDesign['footer'];
    
  //   return {
  //     'navbar': NavbarComponent,
  //     'hero': HeroComponent, 
  //     'about': AboutComponent, 
  //     'faq': FAQComponent, 
  //     'service': ServiceComponent, 
  //     'contact': ContactComponent, 
  //     'testimonials': TestimonialsComponent,
  //     'footer': FooterComponenet
  //   };

    
  // }



  // const [isPopupOpen, setIsPopupOpen] = useState(true);
 
  // useEffect(() => {
  //   const popupTimeout = setTimeout(() => {
  //     closePopup();
  //   }, 5000); // 5000 milliseconds (5 seconds)

  //   return () => {
  //     clearTimeout(popupTimeout);
  //   };
  // }, []);

  // const closePopup = () => {
  //   setIsPopupOpen(false);
  // };
  // const [currentDesign, setCurrentDesign] = useState(generateRandomDesign());
  

  // const guessClassifier = (design) => {
  //   if (design) {
  //     console.log(design);
  //     const guess = net.run(design);
  //     if (guess > 0.5) {
  //       console.log(guess + " Good!");
  //     } else {
  //       console.log(guess+ " Bad!");
  //     }
  //   } else {
  //     console.error("Design is null or undefined");
  //   }
  // };

  // const classifierButton = (value) => {
  //     const randomDesignQuantities = generateRandomQuantities();
  //     const randomDesign = generateRandomDesign();
  //     setTrainingData(prevData => [
  //       ...prevData,
  //       {
  //         input: randomDesignQuantities,
  //         output: [value]
  //       }
  //     ]);
  //     setCurrentDesign(randomDesign);
  // }

  // const print = () => {
  //   console.log(JSON.stringify(trainingData));
  // }

  // useEffect(() => {
  //   setCurrentDesign(currentDesign);
  //   guessClassifier(generateRandomQuantities());
  // }, [currentDesign]);

  
  return (
    <div className="overflow-x-hidden bg-white">
       <Router>
          <Routes>
            <Route path="/" element={
              <>
                <Navbar_3></Navbar_3>
                <Hero_1></Hero_1>
                <Testimonials_1></Testimonials_1>
                <Service_8></Service_8>
                <Service_9></Service_9>
                <br></br><br></br>
                {/* <About_6></About_6> */}
                <Contact_1></Contact_1>
                <Footer_1></Footer_1>
              </>
            
            
            
            } />
            {/* <Route path="/prices" element={
              <>
                <Navbar_3></Navbar_3>
                <Prices_1></Prices_1>
                <Prices_4></Prices_4>
                <Prices_5></Prices_5>
                <Prices_6></Prices_6>
                <Prices_8></Prices_8>
                <Prices_7></Prices_7>
                
              </>
            } />*/}
          </Routes> 
        </Router>
      
      {/* <Navbar_1></Navbar_1> */}
      {/* {isPopupOpen && <PopupImage onClose={closePopup} />} */}

      {/* <Navbar_2></Navbar_2> */}
      {/* <Navbar_3></Navbar_3> */}
      {/* <StringToComponent componentName={currentDesign["navbar"]}></StringToComponent>
      <div className='pt-[70px] dark:bg-slate-800'>
        <StringToComponent componentName={currentDesign["hero"]}></StringToComponent>
        <StringToComponent componentName={currentDesign["about"]}></StringToComponent>
        <StringToComponent componentName={currentDesign["testimonials"]}></StringToComponent>
        <StringToComponent componentName={currentDesign["service"]}></StringToComponent>
        <StringToComponent componentName={currentDesign["faq"]}></StringToComponent>
        <StringToComponent componentName={currentDesign["contact"]}></StringToComponent>
        <StringToComponent componentName={currentDesign["footer"]}></StringToComponent>

      </div>
      
      
      
      <button className="btn" onClick={() => classifierButton(1)}>Good</button>
      <button className="btn ml-3" onClick={() => classifierButton(0)}>Bad</button>     
      <button className="btn ml-3" onClick={print}>Print</button>   */}
      {/* <DesignGenerator></DesignGenerator> */}
    </div>  
    
  );
}

export default App;
